import { CurrencyPipe } from '@angular/common';
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TRANSACTION_TYPES } from '@models/cash-transaction.class';
import { IContract, IContractAccountsCollection } from '@models/contract.class';
import { Store } from '@ngrx/store';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { isEmpty, isEqual } from 'lodash';
import * as moment from 'moment-timezone';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';
import { AppState, TRACKING_EVENTS, USER_ROLES } from 'src/app';
import { SideModalComponent } from 'src/components/side-modal/side-modal.component';
import {
  BootstrapService,
  CashService,
  MixpanelService,
  TradeService,
} from 'src/core';
import { OrderByPipe } from 'src/shared/pipes';
import {
  SubTransactionConcept,
  SubTransactionType,
} from '../../../transactions/enums/transactionType.enum';

interface DisplayableTransaction {
  originAccount: string;
  beneficiaryAccount: string;
  operationConcept: string;
  paymentConcept: string;
  numericReference: string;
  trackingKey: string;
  settlementDay: string;
  settlementTime: string;
  fields: TransactionDetailsFields[];
  amount: number;
  url: string;
}

type TransactionDetailsFields = keyof DisplayableTransaction;

@Component({
  selector: 'hb-transactions-cash',
  templateUrl: './transactionsCash.component.html',
  styleUrls: ['../../transactions.component.scss'],
  providers: [CurrencyPipe],
})
export class TransactionsCashComponent implements OnInit, OnDestroy {
  @ViewChild('sideModal') sideModal: SideModalComponent;

  public transactionDetails: Partial<DisplayableTransaction> = {};

  bootstrapPromise: Promise<any>;
  maxDate: any = moment().tz('America/Mexico_City').toDate();
  minDate: any = moment().tz('America/Mexico_City').toDate();

  beginDate: any = moment()
    .tz('America/Mexico_City')
    .subtract(30, 'd')
    .startOf('day')
    .toDate();

  endDate: any = moment().tz('America/Mexico_City').endOf('day').toDate();

  label: any = {
    initial: '',
    final: '',
  };

  public fieldNames: Partial<Record<TransactionDetailsFields, string>> = {
    beneficiaryAccount: 'Cuenta destino',
    paymentConcept: 'Concepto',
    numericReference: 'Referencia numérica',
    trackingKey: 'Clave de rastreo',
    settlementDay: 'Día de aceptación',
    settlementTime: 'Hora de aceptación',
    originAccount: 'Cuenta origen',
  };

  statusTitles: any = {
    1: 'En Reparacion',
    0: 'Pendientes',
    2: 'Detenido',
    64: 'Lista',
    66: 'Detenido',
    10304: 'En cola de envío',
    10688: 'Rechazada',
    11456: 'Exportada',
    14784: 'No Liquidada',
    15296: 'Liquidada',
    63984: 'Cancelada',
    65536: 'Pendientes',
    65538: 'Pendientes',
    65600: 'Lista',
    65602: 'Lista',
    75840: 'En cola de envío',
    76224: 'Rechazada',
    80832: 'Liquidada',
    129520: 'Cancelada',
    '2_': 'Devolución',
    '-1': 'Pendiente',
  };
  statusColors: any = {
    1: 'gray',
    0: 'gray',
    2: 'gray',
    64: 'gray',
    66: 'gray',
    10304: 'gray',
    10688: 'red',
    11456: 'gray',
    14784: 'red',
    15296: 'black',
    63984: 'red',
    65536: 'gray',
    65538: 'gray',
    65600: 'gray',
    65602: 'gray',
    75840: 'gray',
    76224: 'red',
    80832: 'black',
    129520: 'red',
    '2_': 'black',
    '-1': 'gray',
  };
  public showSkeleton = true;

  source: any[] = [];
  transactions: any[] = [];
  noRows = 0;
  currentRows = 0;
  totalRows = 0;
  totalPages: number;
  page = 50;

  sorting: any = {
    prop: 'date',
    reverse: true,
  };

  selectPageSize: any = [
    { label: '12', value: 12 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ];
  selectedPageSize = this.selectPageSize[2];

  public controls: any = {
    period: '',
    filter: '',
  };

  showTooltipH = false;
  showTooltipR = false;
  areDeposits = false;
  id = -1;
  width = 0;
  helpHeader =
    'Puedes ver los detalles de SPEI al hacer click sobre el estatus.';
  infoSPEI = '';
  statusName = '';
  trackingKey = '';
  operationDateTime: Date;
  beneficiaryAccount = '';
  operationTime: string;
  operationDate: string;
  operationType = 0;
  operationTypeCOM: string;
  additionalInformation = '';
  url = '';
  urlShort = '';
  title = '';

  public constTopTableTooltip = 0;
  public constLeftTableTooltip = 0;

  public constTop = 0;
  private appComponent: any;
  private currentContract: string;
  private speiAccount: any;
  private pageSize = 50;
  private currentPage = 1;
  private sortingProp = 23;
  private sortReverse = false;
  private orderByPipe: OrderByPipe = new OrderByPipe();

  private transactionsSubscription: Subscription;
  private currentContractSubscription: Subscription;
  public initialDateIsSet = false;
  private today = new Date();
  public subTransactionType: any = SubTransactionType;
  private subTransactionTypeSelected: any;

  private userRoleSubscription: Subscription;
  private userGlobalSubscription: Subscription;
  private contractAccountSubscription: Subscription;
  public standardUser = false;
  private isUserGlobal = false;

  private isLoremUpdate$: Subject<boolean> = new Subject();
  private isLoremAccount = false;
  private contractAccountsCollection: IContractAccountsCollection;
  private selectedAccount: any;
  private TRANSACTION_TYPE: any = {
    9: 'Retiro realizado',
    3534: 'Transferencia recibida',
    3535: 'Transferencia enviada',
  };

  constructor(
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
    private tradeService: TradeService,
    private cashService: CashService,
    private mixpanelService: MixpanelService,
  ) {}

  scanForUserTypeContract() {
    this.userGlobalSubscription = this.store
      .select('userGlobal')
      .subscribe((value: any) => {
        this.isUserGlobal = value;
      });
  }

  scanForUserRole() {
    this.userRoleSubscription = this.store
      .select('userRole')
      .pipe(filter((value: any) => value !== undefined))
      .subscribe((value: any) => {
        this.standardUser =
          value === USER_ROLES.RI ||
          value === USER_ROLES.SUBDIRECTOR ||
          value === USER_ROLES.READONLY
            ? false
            : true;
      });
  }

  ngOnInit() {
    this.appComponent = document.getElementsByClassName('app-component')[0];
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.store
        .select('currentContract')
        .pipe(
          map((currentContract: any) => currentContract.toJS()),
          filter((currentContract: IContract) => !isEmpty(currentContract)),
          distinctUntilChanged((a: IContract, b: IContract) => {
            const isSameContract = a.contractID === b.contractID;
            const isSameLoremAccount = a.isLoremAccount === b.isLoremAccount;
            return isSameContract && isSameLoremAccount;
          }),
          map((currentContract) => {
            const contractChanged: boolean =
              !this.currentContract ||
              this.currentContract !== currentContract.contractID;
            return [currentContract, contractChanged];
          }),
          tap(([currentContract, _contractChanged]: [IContract, boolean]) =>
            this.isLoremUpdate$.next(currentContract.isLoremAccount),
          ),
        )
        .subscribe(
          ([currentContract, contractChanged]: [IContract, boolean]) => {
            const { contractID, isLoremAccount } = currentContract;
            this.currentContract = contractID;
            this.isLoremAccount = isLoremAccount;

            isLoremAccount && this.getContractAccount();

            this.getSpeiAccount();
          },
        );
    });

    this.scanForUserRole();
    this.scanForUserTypeContract();

    this.updateLabels(this.beginDate, this.endDate);
  }

  ngOnDestroy() {
    this.toggleTradeBlotter(false);

    if (this.currentContractSubscription) {
      this.currentContractSubscription.unsubscribe();
    }

    if (this.transactionsSubscription) {
      this.transactionsSubscription.unsubscribe();
    }

    if (this.contractAccountSubscription) {
      this.contractAccountSubscription.unsubscribe();
    }
  }

  onScroll() {
    this.showTooltipR = false;
    this.id = -1;
  }

  doShow(event: any, showModal: boolean) {
    this.showTooltipR = true;
    const tooltipLeft = document.querySelector('.tooltip-left');
    if (tooltipLeft !== null) {
      (tooltipLeft as HTMLElement).style.visibility = 'visible';
    }
    this.changePositionTooltip(event);

    if (showModal) {
      this.sideModal.showModal();
    }
  }

  changePositionTooltip(event: any) {
    const tooltiPosition = document.getElementsByClassName(
      '.transactions__tooltip--status',
    );
    if (tooltiPosition !== null) {
      this.constTop = event.clientY - 5;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    this.id = undefined;
    this.showTooltipH = false;
  }

  mouseLeave(div: any, text: string) {
    if (div && div.toElement) {
      this.title =
        div.toElement.offsetWidth < div.toElement.scrollWidth
          ? this.textToTitleCase(text)
          : '';
    } else {
      this.title = undefined;
    }
  }

  public hideTransactionDetailsModal() {
    this.sideModal.handleHide();
    this.transactionDetails = {};
  }

  getPosition(el: any): any {
    let xPos = 0;
    let yPos = 0;

    while (el) {
      if (el.tagName === 'BODY') {
        const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
        const yScroll = el.scrollTop || document.documentElement.scrollTop;

        xPos += el.offsetLeft - xScroll + el.clientLeft;
        yPos += el.offsetTop - yScroll + el.clientTop;
      } else {
        xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
        yPos += el.offsetTop - el.scrollTop + el.clientTop;
      }

      el = el.offsetParent;
    }
    return {
      x: xPos,
      y: yPos,
    };
  }

  viewTooltipH() {
    this.showTooltipH = this.showTooltipH === true ? false : true;
  }

  onEvent(event: any) {
    event.stopPropagation();
  }

  showTooltip(status: number, type: number): boolean {
    switch (status) {
      case 15296:
      case 80832:
      case 10688:
      case 14784:
      case 63984:
      case 76224:
      case 129520:
      case 999:
        return true;
      default:
        break;
    }

    switch (type) {
      case 8:
        return true;
      default:
        return false;
    }
  }

  public openTransactionDetails(transaction: any) {
    switch (transaction.operationStatus) {
      case 15296:
      case 80832:
        this.transactionDetails = {
          ...transaction,
          operationConcept: this.TRANSACTION_TYPE[transaction.operationType],
          amount: Math.abs(transaction.amount),
          settlementDay: moment(transaction.settlementDate).format('ll'),
          settlementTime: moment(transaction.settlementDate).format('hh:mm a'),
          beneficiaryAccount:
            '***************' + transaction.beneficiaryAccount.substr(-3),
          fields: [
            'beneficiaryAccount',
            'paymentConcept',
            'numericReference',
            'trackingKey',
            'settlementTime',
            'settlementDay',
          ],
        };
        break;
      case 10688:
      case 14784:
      case 63984:
      case 76224:
      case 129520:
      case 999:
        this.additionalInformation = transaction.additionalInformation;
        this.width = 250;
        this.transactionDetails = {
          ...transaction,
          operationConcept: this.TRANSACTION_TYPE[transaction.operationType],
          amount: Math.abs(transaction.amount),
          settlementDay: moment(transaction.settlementDate).format('ll'),
          settlementTime: moment(transaction.settlementDate).format('hh:mm a'),
          beneficiaryAccount:
            '***************' + transaction.beneficiaryAccount.substr(-3),
          fields: [
            'beneficiaryAccount',
            'paymentConcept',
            'numericReference',
            'trackingKey',
            'settlementTime',
            'settlementDay',
          ],
        };
        break;
      default:
        break;
    }

    if (
      transaction.operationType === SubTransactionType.TRANSFERS_IN ||
      transaction.operationType === SubTransactionType.TRANSFERS_OUT
    ) {
      this.getTransactionDetail(transaction);
    }

    switch (transaction.operationType) {
      case 8:
      case 3867:
        this.transactionDetails = {
          ...transaction,
        };
        break;
      default:
        break;
    }
  }

  getSpeiAccount() {
    this.cashService.getCLABE(this.currentContract).subscribe((value: any) => {
      this.speiAccount = value.response;
      this.getData();
      this.toggleTradeBlotter(true);
    });
  }

  getData(): void {
    const info: any = {
      startDate: this.beginDate,
      endDate: this.endDate,
      contractId: this.currentContract,
      speiAccount: this.speiAccount,
    };
    const BEGIN_DATE = moment(this.beginDate);
    const END_DATE = moment(this.endDate);
    const FILTER_PERIOD = END_DATE.diff(BEGIN_DATE, 'days');

    this.transactionsSubscription = this.tradeService
      .getHistoricalCashOperations(info)
      .subscribe(
        (data: any) => {
          this.mixpanelService.track(
            TRACKING_EVENTS.movements_filter_period.event,
            {
              ...TRACKING_EVENTS.movements_filter_period.success,
              Type: FILTER_PERIOD,
            },
          );
          let dataFilter: any = [];
          if (data) {
            if (this.operationType === SubTransactionType.DEPOSITS) {
              dataFilter = data.filter(
                (type: any) =>
                  type.operationType === SubTransactionType.DEPOSITS ||
                  type.operationType === SubTransactionType.ISR ||
                  type.operationType === SubTransactionType.DIVIDENDS_DEPOSIT,
              );
              this.areDeposits = true;
            } else if (this.operationType === SubTransactionType.RETREATS) {
              dataFilter = data.filter(
                (type: any) =>
                  type.operationType === SubTransactionType.RETREATS,
              );
              this.areDeposits = false;
            } else if (
              this.operationType === SubTransactionType.TRANSFERS_IN ||
              this.operationType === SubTransactionType.TRANSFERS_OUT
            ) {
              dataFilter = data.filter(
                (type: any) =>
                  type.operationType === SubTransactionType.TRANSFERS_OUT ||
                  type.operationType === SubTransactionType.TRANSFERS_IN,
              );
              this.areDeposits = false;
            } else {
              dataFilter = data;
              this.areDeposits = false;
            }

            this.noRows = dataFilter !== undefined ? dataFilter.length : 0;
            this.totalRows = dataFilter.length;

            if (this.noRows > 0) {
              for (const item of dataFilter) {
                let date: any;
                date = moment(item.operationDate);
                item.operationTime = date.format('hh:mm:ss');
                item.operationDate = date.format('DD/MM/YYYY');
                item.dayOfWeek = moment(date).day();
                item.operationStatusName = 'Realizada';
                item.operationTitle =
                  this.TRANSACTION_TYPE[item.operationType] ||
                  item.operationConcept;

                if (item.operationType === SubTransactionType.RETREATS) {
                  if (item.operationStatusName !== 'Devolución') {
                    item.amount = -Math.abs(item.amount);
                    item.operationStatusName =
                      this.statusTitles[item.operationStatus.toString()];
                    item.statusColor =
                      this.statusColors[item.operationStatus.toString()];
                    item.operationTitle =
                      this.TRANSACTION_TYPE[item.operationType];
                  }
                  const status = [-1, 0];

                  if (
                    item?.trackingKey !== '' &&
                    status.indexOf(item.operationStatus) > -1
                  ) {
                    item.operationStatusName = 'Realizada';
                    item.statusColor = 'black';
                  }
                }

                if (
                  item.operationConcept ===
                  SubTransactionConcept.INTEREST_PAYMENT_COUPON
                ) {
                  item.operationTitle = item.operationConcept;
                  item.operationStatusName = 'Realizada';
                  item.isCupon = true;
                  item.amount = Math.abs(item.amount);
                }

                if (item.operationStatusName === 'Devolución') {
                  item.operationStatusName = 'Devolución';
                  item.statusColor = 'black';
                  item.operationStatus = 999;
                }

                item.showTooltip = this.showTooltip(
                  item.operationStatus,
                  item.operationType,
                );

                if (item.operationType === SubTransactionType.THIRD_PARTIES) {
                  item.showTooltip = true;
                }
              }

              this.transactions = dataFilter;
              this.source = dataFilter;
              this.getTotalTransactions(this.transactions);
              this.showSkeleton = false;
            } else {
              this.source = [];
              this.transactions = [];
              this.showSkeleton = false;
            }
          } else {
            this.transactions = [];
            if (this.noRows <= 0) {
              this.totalRows = 0;
              this.currentRows = 0;
              this.showSkeleton = false;
            }
          }
        },
        (error) => {
          this.mixpanelService.track(
            TRACKING_EVENTS.movements_filter_period.event,
            {
              ...TRACKING_EVENTS.movements_filter_period.error,
              Type: FILTER_PERIOD,
              Callback: error.message || error.ErrorMessage,
            },
          );
        },
      );
  }

  getMore(): void {
    this.currentPage++;
    this.getTransactionInformation();
  }

  changeBeginDate(event: any): void {
    this.beginDate = event;

    const timeDiff = Math.abs(this.today.getTime() - this.beginDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) - 1;

    if (diffDays < 60) {
      this.maxDate = moment(event)
        .add(diffDays, 'd')
        .tz('America/Mexico_City')
        .toDate();
      this.endDate = moment(event)
        .add(diffDays, 'd')
        .tz('America/Mexico_City')
        .toDate();
    } else {
      this.maxDate = moment(event)
        .add(60, 'd')
        .tz('America/Mexico_City')
        .toDate();
      this.endDate = moment(event)
        .add(60, 'd')
        .tz('America/Mexico_City')
        .toDate();
    }

    this.validateDates();
    this.updateLabels(this.beginDate, this.endDate);
    this.forceFinalDateChange();
  }

  changeEndDate(event: any): void {
    this.showSkeleton = true;
    this.endDate = moment(event)
      .tz('America/Mexico_City')
      .endOf('day')
      .toDate();
    this.validateDates();
    this.getTransactionInformation();
    this.initialDateIsSet = false;
    this.appComponent.classList.remove('unscrollable');
    this.updateLabels(this.beginDate, this.endDate);
  }

  applyToday(): void {
    setTimeout(() => {
      this.initialDateIsSet = false;
      const today = document.getElementsByClassName('mat-calendar-body-today');
      if (today.length > 0) {
        today[0].addEventListener('click', () => {
          this.showSkeleton = true;
          this.validateDates();
          this.getTransactionInformation();
          this.appComponent.classList.remove('unscrollable');
        });
      }
    }, 50);

    setTimeout(() => {
      this.initialDateIsSet = false;
      const lastToday = document.getElementsByClassName(
        'mat-calendar-body-active',
      );
      if (lastToday.length > 0) {
        lastToday[0].addEventListener('click', () => {
          this.showSkeleton = true;
          this.validateDates();
          this.getTransactionInformation();
          this.appComponent.classList.remove('unscrollable');
        });
      }
    }, 50);
  }

  forceFinalDateChange() {
    this.initialDateIsSet = true;
    this.appComponent.classList.add('unscrollable');

    setTimeout(() => {
      const datePickerBackdrop = document.getElementsByClassName(
        'cdk-overlay-backdrop-showing',
      )[0];
      if (datePickerBackdrop) {
        datePickerBackdrop.classList.add('unclickable');
      }
    }, 100);
  }

  onChangePageSize(event: any, item: any): void {
    window.scrollTo(0, 0);
    this.selectedPageSize = item;
    this.clearParamsToSearch();
    this.getTransactionInformation();
  }

  /**
   * Used to clear params and restore dates.
   */
  restoreParams(): void {
    this.totalRows = 0;
    this.clearParamsToSearch();
    this.beginDate = moment().tz('America/Mexico_City').startOf('day').toDate();
    this.endDate = moment().tz('America/Mexico_City').endOf('day').toDate();
  }

  /**
   * Used to generate CSV file for historical transactions
   */
  parseData(selector: string, headers?: object): void {
    let generatedFile;
    const date = new Date().getTime();
    const length = this.transactions.length;
    const fileHeaders = {
      accountId: 'Contrato',
      date: 'Fecha',
      time: 'Hora',
      folio: 'Folio',
      concept: 'Movimiento',
      issueId: 'Emisora',
      amount: 'Monto',
      status: 'Estatus',
    };

    const exportObject = [];
    exportObject.push(fileHeaders);

    for (let i = 0; i < length; i += 1) {
      const transactionData: any = {
        accountId: this.currentContract,
        date: this.transactions[i].operationDate,
        time: this.transactions[i].operationTime,
        folio: this.transactions[i].trackingKey,
        concept: this.transactions[i].operationConcept,
        issueId: this.transactions[i].issueId,
        amount:
          this.transactions[i].operationTitle ===
          SubTransactionConcept.INTEREST_PAYMENT_COUPON
            ? Math.abs(this.transactions[i].amount)
            : new CurrencyPipe('es-MX').transform(
                this.transactions[i].amount,
                'MXN',
                'symbol-narrow',
                '1.2-2',
              ),
        status: this.transactions[i].operationStatusName,
      };
      exportObject.push(transactionData);
    }
    generatedFile = new AngularCsv(
      exportObject,
      `GBM_Homebroker_Historial_de_Transacciones_${date}`,
    );
  }

  getTotalTransactions(transactions: any): void {
    this.currentRows = transactions.length;
  }

  toggleTradeBlotter(isVisible: boolean) {
    const tradeBlotter = document.getElementsByClassName('trade-blotter');
    [].slice.call(tradeBlotter).forEach((value: any) => {
      (value as HTMLElement).style.display = isVisible ? 'none' : 'block';
    });
  }

  changeFilter(option: number) {
    this.showSkeleton = true;
    switch (option) {
      case 1:
        this.operationType = SubTransactionType.ALL;
        this.operationTypeCOM = '';
        break;
      case 2:
        this.operationType = SubTransactionType.DEPOSITS;
        this.operationTypeCOM = TRANSACTION_TYPES.deposit;
        break;
      case 3:
        this.operationType = SubTransactionType.RETREATS;
        this.operationTypeCOM = TRANSACTION_TYPES.withdrawal;
        break;
      case 4:
        this.operationType = SubTransactionType.TRANSFERS_IN;
        this.operationTypeCOM = `${TRANSACTION_TYPES.transfer_in},${TRANSACTION_TYPES.transfer_out}`;
        break;
      default:
        this.operationType = SubTransactionType.ALL;
        this.operationTypeCOM = '';
        break;
    }
    this.subTransactionTypeSelected = option;
    this.transactions = [];
    this.getTransactionInformation();
  }

  setSortingProp(property: string): void {
    if (!property || property === '') {
      return;
    }

    if (this.sorting.prop === property) {
      this.sorting.reverse = !this.sorting.reverse;
    } else {
      this.sorting.prop = property;
      this.sorting.reverse = true;
    }

    this.sortData();
  }

  public showTooltipTable(event: MouseEvent): void {
    const tooltipElement = (event.target as Element).lastElementChild;
    if (tooltipElement) {
      const { top, left } = (event.target as Element).getBoundingClientRect();
      this.constTopTableTooltip = top + 70;
      this.constLeftTableTooltip = left - 10;

      tooltipElement.classList.add('show');
    }
  }

  public hideTooltipTable(event: MouseEvent): void {
    const tooltipElement = (event.target as Element).lastElementChild;

    if (tooltipElement) {
      tooltipElement.classList.remove('show');
    }
  }

  private sortData(): void {
    this.transactions = this.orderByPipe.transform(
      this.transactions,
      this.getConvertSortingProp(),
    );
  }

  private getConvertSortingProp(): string {
    return this.sorting.reverse ? `-${this.sorting.prop}` : this.sorting.prop;
  }

  private validateDates(): void {
    const diffMin: number = moment(this.endDate).diff(
      this.beginDate,
      'minutes',
    );
    if (diffMin <= 0) {
      this.endDate = moment().tz('America/Mexico_City').endOf('day').toDate();
    }
  }

  private clearParamsToSearch(): void {
    this.noRows = undefined;
    this.totalRows = 0;
    this.currentRows = 0;
    this.currentPage = 1;
    this.transactions.length = 0;
    this.source.length = 0;
  }

  private parseDate(date: Date): string {
    return `${date.getDate()} · ${date.getMonth() + 1} · ${date.getFullYear()}`;
  }

  private updateLabels(initialDate: Date, finalDate: Date): void {
    this.label = {
      initial: this.parseDate(initialDate),
      final: this.parseDate(finalDate),
    };
  }

  private getTransactionInformation() {
    this.totalRows = 0;
    this.noRows = 0;
    this.currentRows = 0;
    this.transactions = [];
    this.source = [];

    this.getData();
  }

  private getContractAccount() {
    this.contractAccountSubscription = this.store
      .select('contractAccountsCollection')
      .pipe(
        map((contractsComMap: any) => contractsComMap.toJS()),
        filter(
          (contractsCom: {
            loaded: boolean;
            loading: boolean;
            data: IContractAccountsCollection;
          }) => contractsCom.loaded,
        ),
        map((collection) => collection.data),
        distinctUntilChanged((a, b) => isEqual(a, b)),
      )
      .subscribe((collection: any) => {
        this.contractAccountsCollection = collection;
        this.selectedAccount = collection.accounts[this.currentContract];
      });
  }

  private getTransactionDetail(order: any) {
    const TRANSACTION_TYPE_TEXT: any = {
      3535: 'transfer_out',
      3534: 'transfer_in',
    };
    this.infoSPEI = '';

    this.tradeService
      .getTransferDetail(
        this.selectedAccount.contractId,
        this.selectedAccount.accountId,
        order.trackingKey,
        TRANSACTION_TYPE_TEXT[order.operationType],
      )
      .subscribe((detail: any) => {
        if (detail) {
          const { accountRelation, accounts } = this.contractAccountsCollection;
          const legacyBeneficiaryAccountId =
            accountRelation[detail.target_account_id];
          const legacyOriginAccountId =
            accountRelation[detail.source_account_id];
          const beneficiaryAccount = accounts[legacyBeneficiaryAccountId].name;
          const originAccount = accounts[legacyOriginAccountId].name;

          const operationConcept =
            this.TRANSACTION_TYPE[order.operationType] || order.operationType;

          const operationTime = moment(detail.created_at).format('hh:mm a');
          const operationDate = moment(detail.created_at).format('ll');

          this.transactionDetails = {
            amount: detail.amount,
            operationConcept,
            originAccount,
            beneficiaryAccount,
            settlementTime: operationTime,
            settlementDay: operationDate,
            fields: [
              'beneficiaryAccount',
              'originAccount',
              'settlementTime',
              'settlementDay',
            ],
          };
        }
      });
  }

  private textToTitleCase(text: string): string {
    return `${text.slice(0, 1).toUpperCase()}${text
      .slice(1, text.length)
      .toLowerCase()}`;
  }
}
